import axios, {
  AxiosResponse,
  HttpStatusCode,
  InternalAxiosRequestConfig,
} from 'axios'
import { isAppResponse } from '../Utils/RequestUtil'
import { AppError } from '../Entities/BaseApi'
import { onUnauthorized } from '../Utils'
import { pp } from '../Utils/LogUtil'
import { getCookie } from 'cookies-next'

export const TOKEN =
  '' +
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9kZS1nZW5raS5nZW5raW1pcnUuanBcL2FwaVwvdjFcL2xvZ2luIiwiaWF0IjoxNjg2MjgxNTMwLCJleHAiOjE2ODg4NzM1MzAsIm5iZiI6MTY4NjI4MTUzMCwianRpIjoiZVRhMElaYVBNUEZyTGtHNyIsInN1YiI6MTcyOCwicHJ2IjoiYzhlZTFmYzg5ZTc3NWVjNGM3Mzg2NjdlNWJlMTdhNTkwYjZkNDBmYyJ9.PVy4rcM4uGJ5YKMjWylB3e81DFG933eC8X4cSuivpTY'

const BASE_URL_DEV = 'https://de-genki.genkimiru.jp/api/v1/'
const BASE_URL_STG = 'https://st-genki.genkimiru.jp/api/v1/'
const BASE_URL_PRO = 'https://api.genkimiru.jp/api/v1/'

const axiosClient = axios.create({
  baseURL: BASE_URL_PRO,
  headers: {
    'Content-Type': 'application/json',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    // token: TOKEN,
    token: getCookie('token'),
  },
})

// Add a request interceptor
axiosClient.interceptors.request.use(
  function (value: InternalAxiosRequestConfig<any>) {
    // Do something before request is sent
    return value
  },

  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
axiosClient.interceptors.response.use(
  function (response: AxiosResponse) {
    pp('axiosClient.interceptors.response.success()')
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const resData = response.data

    if (isAppResponse(resData)) {
      const { status, body } = resData
      if (status !== HttpStatusCode.Ok) {
        const bodyError = body as unknown as string[]
        const errorCode = bodyError[0]
        const appError: AppError = {
          errorCode: errorCode,
        }
        console.log(appError)
        return Promise.reject(appError)
      }
    }
    return resData
  },
  function (error) {
    pp('axiosClient.interceptors.response.error()')
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error?.response?.status === HttpStatusCode.Unauthorized) {
      onUnauthorized()
    }
    return Promise.reject(error)
  }
)

export default axiosClient
